import { api } from './authService';

export const sitesService = {
    // Получить все сайты пользователя
    getUserSites: async () => {
      const response = await api.get('/sites');
      return response.data; // Важно! Возвращаем только data
    },
    
    // Получить сайт по ID
    getSite: async (id) => {
      const response = await api.get(`/sites/${id}`);
      return response.data;
    },
    
    // Создать новый сайт
    createSite: async (data) => {
      const response = await api.post('/sites', data);
      return response.data;
    },
    
    // Добавить участника на сайт
    addMember: async (siteId, userId, role = 'member') => {
      const response = await api.post(`/sites/${siteId}/members`, { userId, role });
      return response.data;
    },
    
    // Получить каналы сайта
    getSiteChannels: async (siteId) => {
      const response = await api.get(`/sites/${siteId}/channels`);
      return response.data;
    },
    deleteSite: async (siteId) => {
        const response = await api.delete(`/sites/${siteId}`);
        return response.data;
      },
    updateSite: async (siteId, data) => {
        const response = await api.put(`/sites/${siteId}`, data);
        return response.data;
    },
    getSiteMembers: async (siteId) => {
        const response = await api.get(`/sites/${siteId}/members`);
        return response.data;
    },
    // Удалить участника с сайта
    removeMember: async (siteId, userId) => {
        const response = await api.delete(`/sites/${siteId}/members/${userId}`);
        return response.data;
    },
    getUserSitesWithUnread: () => 
        api.get('/sites/with-unread').then(res => res.data),
  };